import BaseRequest from './index'
import {
    GET_FAQS,
  } from "./api";
import {
} from './types'

class FaqService extends BaseRequest {
    constructor() {
      super();
      this.bindMethods();
    }
    bindMethods() {
      this.faqAnswers = this.faqAnswers.bind(this);
    }
    async faqAnswers<T>(): Promise<T> {
      return await this.api.get(GET_FAQS);
    }
  }
  const faqService = new FaqService();
  
  export default faqService;